var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-download",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
          defaultGrade: false,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentFile !== null
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-download-content",
                        },
                        [
                          _vm.currentInfo !== "" && !_vm.userHasDownloaded
                            ? _c(
                                "div",
                                {
                                  staticClass: "messagebox messagebox_info",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.currentInfo) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentSuccess !== "" && _vm.userHasDownloaded
                            ? _c(
                                "div",
                                {
                                  staticClass: "messagebox messagebox_info",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.currentSuccess) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-block-download-file-item",
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    download: _vm.currentFile.name,
                                    title: _vm.$gettext("Datei herunterladen"),
                                    href: _vm.currentFile.download_url,
                                  },
                                  on: {
                                    click: _vm.handleDownload,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "cw-block-file-info",
                                      class: [
                                        "cw-block-file-icon-" +
                                          _vm.currentFile.icon,
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.currentFile.name) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "cw-block-download-content",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "cw-block-download-file-item-not-available",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cw-block-file-info cw-block-file-icon-none",
                                },
                                [
                                  _c("translate", [
                                    _vm._v("Datei ist nicht verfügbar"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Überschrift")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTitle,
                                    expression: "currentTitle",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentTitle,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTitle = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Datei")]),
                              _vm._v(" "),
                              _c("courseware-file-chooser", {
                                on: {
                                  selectFile: _vm.updateCurrentFile,
                                },
                                model: {
                                  value: _vm.currentFileId,
                                  callback: function callback($$v) {
                                    _vm.currentFileId = $$v
                                  },
                                  expression: "currentFileId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Infobox vor Download")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentInfo,
                                    expression: "currentInfo",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentInfo,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentInfo = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [
                                _vm._v("Infobox nach Download"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentSuccess,
                                    expression: "currentSuccess",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentSuccess,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentSuccess = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [
                                _vm._v("Fortschritt erst beim Herunterladen"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentGrade,
                                      expression: "currentGrade",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentGrade = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "false",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Nein")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "true",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Ja")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c(
                    "p",
                    [
                      _c("translate", [
                        _vm._v("Informationen zum Download-Block"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }